import { Application } from '@hotwired/stimulus'
import AccordionController from './accordion_controller'
import ButtonChoicesController from './button_choices_controller'
import DropdownController from './dropdown_controller'
import ModalController from './modal_controller'
import NavLinkController from './nav_link_controller'
import RadioButtonsController from './radio_buttons_controller'

const application = Application.start()
application.register('accordion', AccordionController)
application.register('button-choices', ButtonChoicesController)
application.register('dropdown', DropdownController)
application.register('modal', ModalController)
application.register('nav-link', NavLinkController)
application.register('radio-buttons', RadioButtonsController)
